<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="10">
        <el-col :span="10">
          <el-row :gutter="10">
            <el-col :span="14">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item
                    :label="$l('INDEX.table_label_custName') || '客户'"
                  >
                    <dict-select
                      v-model="formData.custCode"
                      url="/master/common/dict/customerSelect"
                      :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                      size="small"
                      style="width: 100%"
                      filterable
                      clearable
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item
                    :label="
                      $l('INDEX.order_form_label_endCustCode') || '终端客户'
                    "
                  >
                    <dict-select
                      v-model="formData.endCustCode"
                      url="/master/common/dict/customerSelect"
                      :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                      size="small"
                      style="width: 100%"
                      filterable
                      clearable
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item
                    :label="$l('form_label_taskDesc') || '导出任务名称'"
                    prop="exportTaskName"
                  >
                    <dict-select
                      v-model="formData.exportTaskName"
                      url="/sys/customer/export/template/task/dictSelect"
                      :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                      size="small"
                      style="width: 100%"
                      filterable
                      clearable
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="10">
              <el-form-item
                :label="$l('form_label_templateName') || '模板名称'"
                prop="templateCode"
              >
                <br />
                <ChooseTemplate
                  :templateThumbnailUrl.sync="formData.templateThumbnailUrl"
                  @updateThumbnail="updateThumbnail"
                  :disabled="disabled"
                  :width="'150px'"
                  :height="'150px'"
                />
                <div class="template-text" v-if="formData.templateName">
                  <i class="el-icon-document"></i>
                  {{ formData.templateName }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_dataSource') || '数据源'"
                prop="dataSource"
              >
                <el-input
                  clearable
                  v-model="formData.dataSource"
                  :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                  size="small"
                  maxlength="50"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_customerTemplateName') || '客户模板名称'"
                prop="customerTemplateName"
              >
                <el-input
                  clearable
                  v-model="formData.customerTemplateName"
                  :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                  size="small"
                  maxlength="200"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_customerTemplateDesc') || '客户模板描述'"
              >
                <el-input
                  clearable
                  v-model="formData.customerTemplateDesc"
                  :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                  type="textarea"
                  rows="3"
                  size="small"
                  maxlength="500"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="d-flex justify-content-end mb-2 mt-2">
              <el-button
                v-if="!disabled"
                type="primary"
                size="small"
                @click="save()"
                >{{ $l('INDEX.btn_save') || '保存' }}</el-button
              >
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="14">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_fieldSetting') || '导出字段配置'"
                prop="fieldSetting"
              >
                <VueJSONEditor
                  id="field-setting-editor"
                  :content="content"
                  :onChange="onChange"
                  :onRenderMenu="onRenderMenu"
                  :readOnly="disabled"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import {mapActions} from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import VueJSONEditor from './VueJSONEditor'
import ChooseTemplate from './choose-template'
export default {
  components: {VueJSONEditor, ChooseTemplate},
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    customerExportTemplateCode: String,
    isCopy: Boolean,
    params: {type: Object, default: () => {}},
  },
  data() {
    return {
      formData: {templateThumbnailUrl: ''},
      rules: {
        templateCode: [
          {
            validator: (rule, value, callback) => {
              if (this.formData.templateCode) {
                callback()
              } else {
                callback(this.$l('INDEX.tips_select_data') || '请选择...')
              }
            },
          },
        ],
        exportTaskName: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        dataSource: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        customerTemplateName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    content() {
      return {text: this.formData.fieldSetting || ''}
    },
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.customerExportTemplateCode) return

      this.$api
        .sysCustomerExportTemplateDetailApi({
          customerExportTemplateCode: this.customerExportTemplateCode,
        })
        .then((res) => {
          this.formData = res.body
          if (this.isCopy) {
            this.formData.customerExportTemplateCode = null
          }
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .sysCustomerExportTemplateSaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          if (!this.customerExportTemplateCode || this.isCopy) {
            this.closeCurPage()
          } else {
            this.getData()
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    onChange(content) {
      let data = content.text
      if (content.json) {
        data = JSON.stringify(content.json)
      }
      this.formData.fieldSetting = data
    },
    onRenderMenu(mode, items) {
      return items.filter((t) => !['text', 'tree'].includes(t.text))
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },

    updateThumbnail(data) {
      this.formData.templateCode = data.templateCode
      this.formData.templateName = data.templateName
      this.formData.templateThumbnailUrl = data.templateThumbnailUrl
    },
  },
}
</script>
<style lang="scss">
#field-setting-editor {
  .jse-main {
    min-height: 500px;
  }
}

.template-text {
  margin-right: 50px;
  width: 175px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
